import styled from 'styled-components';

export const SelectGroup = styled.div<{ bgColor?: string }>`
  align-items: stretch;
  background-color: ${({ bgColor }) => bgColor || 'var(--grey-75)'};
  border-radius: 6px;
  box-sizing: border-box;
  display: flex;
  flex: 1 1 0%;
  min-height: 36px;
  overflow: hidden;
  position: relative;
  width: 100%;

  select {
    appearance: none;
    background: transparent;
    border: none;
    border-radius: 6px;
    box-shadow: var(--shadow-inset-sm);
    color: var(--grey-600);
    cursor: pointer;
    font-family: var(--raleway);
    font-size: 13px;
    font-weight: 400;
    height: 100%;
    left: 0;
    min-width: 0;
    overflow: hidden;
    padding: 8px 10px;
    padding-right: 40px;
    position: absolute;
    text-overflow: ellipsis;
    top: 0;
    white-space: nowrap;
    width: 100%;
    z-index: 2;
    &:focus {
      box-shadow:
        var(--shadow-inset-sm),
        0 0 0 2px rgba(200, 16, 46, 0.2);
      outline: none;
    }
  }
  .icon {
    align-items: center;
    background: inherit;
    border-radius: 0 6px 6px 0;
    box-shadow: var(--shadow-inset-sm);
    color: var(--grey-600);
    display: flex;
    font-size: 16px;
    height: 100%;
    justify-content: center;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
    width: 32px;
    z-index: 1;
  }
`;
